import { z } from 'zod';
/** docs section 18 "Lead Conversion" / docs/architecture/03-database.md §
 * lead conversion — match-or-create for company and contact, an optional
 * deal, and the lead itself is kept (never deleted) with its history intact. */
export const convertLeadSchema = z.object({
    company: z
        .discriminatedUnion('mode', [
        z.object({ mode: z.literal('link'), companyId: z.string().uuid() }),
        z.object({ mode: z.literal('create'), name: z.string().trim().min(1).max(200).optional() }),
    ])
        .optional(),
    contact: z.discriminatedUnion('mode', [
        z.object({ mode: z.literal('link'), contactId: z.string().uuid() }),
        z.object({ mode: z.literal('create') }),
    ]),
    deal: z
        .object({
        name: z.string().trim().min(1).max(200).optional(),
        pipelineId: z.string().uuid(),
        stageId: z.string().uuid(),
        amount: z.coerce.number().nonnegative(),
        currency: z.string().length(3).default('USD'),
        expectedCloseDate: z.string().date().optional(),
        source: z.string().trim().max(200).optional(),
    })
        .optional(),
});
export const convertLeadResponseSchema = z.object({
    leadId: z.string().uuid(),
    contactId: z.string().uuid(),
    companyId: z.string().uuid().nullable(),
    opportunityId: z.string().uuid().nullable(),
});
//# sourceMappingURL=convert.js.map